import React from "react";
import PropTypes from "prop-types";

export function ConditionOperator({ operator }) {
  return (
    <div data-test="condition-operator">
      {operator?.toLowerCase() || "When"}
    </div>
  );
}

ConditionOperator.propTypes = {
  operator: PropTypes.string,
};

ConditionOperator.defaultProps = {
  operator: null,
};

export default ConditionOperator;
